import { List } from 'immutable'
import { SET_RESOLVER_DATA } from 'services/resolver/actions'
import { get as getConfig } from 'config'
import _get from 'lodash/get'
import { URL_GET_STARTED } from 'services/url/constants'
import { addNewRelicAction } from 'services/app/_newrelic'
import {
  wishrouteSignup,
  WISHROUTE_SIGNUP_START,
  WISHROUTE_EVENT_OPT_IN,
} from '.'
import * as actions from './actions'

const config = getConfig()
const { features } = config
const wishrouteEnabled = !!_get(features, 'wishroute')

function isWishrouteEnabled () {
  return wishrouteEnabled
}

export function watchWishrouteSignup ({ after }) {
  return after([
    actions.SET_WISHROUTE_SIGNUP,
  ], async ({ dispatch, state }) => {
    const { auth, wishroute, user } = state
    const eventType = WISHROUTE_SIGNUP_START
    const userName = user.getIn(['data', 'firstName'], '')
    const focusAreas = wishroute.getIn(['data', 'focus'], List())
    const options = wishroute.getIn(['data', 'options'], List())
    const zoneinfo = Intl.DateTimeFormat().resolvedOptions().timeZone
    const phone = wishroute.getIn(['data', 'phone'], '')

    dispatch({
      type: actions.SET_WISHROUTE_SIGNUP_PROCESSING,
      payload: true,
    })

    const data = await wishrouteSignup(
      {
        auth,
        data: {
          eventType,
          userName,
          focusAreas,
          options,
          zoneinfo,
          phone,
        },
      },
    )
    dispatch({
      type: actions.SET_WISHROUTE_SIGNUP_DATA,
      payload: { data, processing: false },
    })
  })
}

export function watchWishrouteSignupData ({ after }) {
  return after([
    actions.SET_WISHROUTE_SIGNUP_DATA,
  ], async ({ state, action }) => {
    const { user } = state
    const { payload } = action
    const uuid = user.getIn(['data', 'uuid'])
    const optIn = _get(payload, 'data.opt_in')
    const wishrouteOptInSuccess = _get(payload, 'data.success')
    const eventData = { uuid, wishrouteOptInSuccess }
    const newRelicEvent = {
      wishrouteEventType: WISHROUTE_EVENT_OPT_IN,
      wishrouteEventData: eventData,
    }

    if (optIn) {
      addNewRelicAction('Wishroute', newRelicEvent)
    }
  })
}

export function watchWishrouteSetResolverData ({ after }) {
  return after([
    SET_RESOLVER_DATA,
  ], async ({ dispatch, state, prevState }) => {
    const { resolver: nextResolver } = state
    const { resolver: prevResolver } = prevState
    const nextPath = nextResolver.getIn(['data', 'path'])
    const prevPath = prevResolver.getIn(['data', 'path'])

    // delete wishroute data if we are leaving onboarding
    if (prevPath === URL_GET_STARTED && nextPath !== URL_GET_STARTED) {
      dispatch({
        type: actions.DELETE_WISHROUTE_DATA,
      })
    }
  })
    .when(isWishrouteEnabled)
}
